import { ParametersModule } from '../app/available-modules-mapper';
import { UserDependent, UserPrincipal } from '../app/types';
import AppointmentService from '../services/appointment-service';

export interface TwsUserParameters {
  hasAccessToUserRegistration: boolean;
}
class UserContext {
  static patientId: number;
  static holderPatientId: number;
  static twsUserAvailableModules: ParametersModule[];
  static twsUserParameters: TwsUserParameters = UserContext.getTwsUserDefaultParameters();
  static userDependents?: UserDependent[];
  static userPrincipal?: UserPrincipal;

  private static getTwsUserDefaultParameters(): TwsUserParameters {
    AppointmentService.setAppointmentConfigApplicationContext();
    return {
      hasAccessToUserRegistration: true,
    }
  }
}

export default UserContext;